export const joinWithSeparator = (separator: string, ...parts: (string | undefined)[]) => {
  if (!parts) {
    return ``;
  }

  const filtered = new Array(...parts).filter((v) => v);

  return filtered.join(separator);
};
